// import styled from "styled-components";

// export const Container = styled.div`
//   @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
// width: 90%;
// margin: 0 auto;
// }
// `;
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1200px; /* Dopasuj do swoich potrzeb */
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
 min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
  /* Usuń padding dla regulations, policy i gdy modal jest otwarty na urządzeniach mobilnych */
  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    ${({ currentPath, isModalOpen }) => 
      (currentPath === '/regulations' || currentPath === '/policy' || isModalOpen) && 
      `padding: 0;`}
  }
`;